export const LOCAL_ICON_PREFIX = 'local-icon-'
export const EL_ICON_PREFIX = 'el-icon-'

export function getElementPlusIconNames() {
    return elIconsName
}

export function getLocalIconNames() {
    return localIconsName
}